import DoneIcon from '@mui/icons-material/Done';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import dayjs from 'dayjs';
import TextField from '../../Form/TextField/TextField';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';
import classes from '../scss/addEditFormModal.module.scss';
import CustomDayPicker from '../../CustomDayPicker/CustomDayPicker';
import { generalEnums } from '../../../../utils/enums';

import('react-datepicker/dist/react-datepicker.css');
import('../../../../scss/datepicker.css');

function WorksForm(props) {
  dayjs.extend(advancedFormat);
  const { addEditForm, withCurrentlyCheckBox } = props;

  const { t } = useTranslation();

  const changeCurrentlyCheckbox = (e) => {
    addEditForm.setFieldValue('enddate', new Date());
    addEditForm.setFieldValue('currentlyWorkThere', e.target.checked);
  };

  return (
    <div className={`${classes.formContainer} w-full`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <TextField
          placeholder="Job Title"
          label="Job Title"
          labelClass="text-sm"
          inputClass="!text-sm px-3 py-4 text-black !font-normal !rounded-lg"
          value={addEditForm?.values?.title}
          onChange={(e) => {
            addEditForm.setFieldTouched('title', true, true);
            addEditForm.setFieldValue('title', e.target.value, true);
          }}
          error={addEditForm.touched.title && Boolean(addEditForm.errors.title)}
          errorText={addEditForm.touched.title && addEditForm.errors.title}
        />
        <TextField
          placeholder="Company"
          label="Company"
          labelClass="text-sm"
          inputClass="!text-sm px-3 py-4 text-black !font-normal !rounded-lg"
          value={addEditForm?.values?.company}
          onChange={(e) => {
            addEditForm.setFieldTouched('company', true, true);
            addEditForm.setFieldValue('company', e.target.value, true);
          }}
          error={addEditForm.touched.company && Boolean(addEditForm.errors.company)}
          errorText={addEditForm.touched.company && addEditForm.errors.company}
        />

        {/* Start Date */}
        <div className="flex flex-col gap-2">
          <label className="text-black text-sm">{t('common.forms.startdate')}</label>
          <CustomDayPicker
            isMonthYearPicker
            testId="startDate"
            date={addEditForm.values?.startdate || dayjs()}
            changeHandler={(newValue) => addEditForm.setFieldValue('startdate', newValue, true)}
            dayFormat={generalEnums.DATEWITHSTANDARD}
            sx={{
              width: '100%',
              fieldset: {
                legend: {
                  width: 'unset'
                }
              },
              input: {
                fontSize: '14px'
              }
            }}
            rerender
          />
        </div>
        {/* End Date + Checkbox */}
        <div className="flex flex-col gap-2">
          <label className="text-sm text-black">{t('common.forms.enddate')}</label>
          <CustomDayPicker
            testId="endDate"
            date={addEditForm.values?.enddate || dayjs()}
            changeHandler={(newValue) => addEditForm.setFieldValue('enddate', newValue, true)}
            dayFormat={generalEnums.DATEWITHSTANDARD}
            sx={{
              width: '100%',
              fieldset: {
                legend: {
                  width: 'unset'
                }
              },
              input: {
                fontSize: '14px'
              }
            }}
            rerender
          />
          {withCurrentlyCheckBox && (
            <div className={classes.currentCheckBox}>
              <Checkbox
                icon={<div className={classes.customCheck} />}
                checkedIcon={
                  <div className={classes.customCheck}>
                    <DoneIcon />
                  </div>
                }
                onClick={changeCurrentlyCheckbox}
                checked={addEditForm.values?.currentlyWorkThere}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 15 }, padding: 0 }}
              />
              <span className={`${classes.checkBoxLabel} !text-sm`}>I Currently Work Here</span>
            </div>
          )}
        </div>
      </div>

      {addEditForm.touched.currentlyWorkThere && addEditForm.errors.currentlyWorkThere && (
        <ValidationErrorLabel message={addEditForm.errors.currentlyWorkThere} />
      )}

      {/* Description Field */}
      <div className={`${classes.description} ${classes.textField}`}>
        <TextField
          isTextArea
          labelClass="text-sm"
          inputClass="!text-sm px-3 py-3 text-black !font-normal !rounded-lg"
          rows="5"
          variant="standard"
          id="description"
          name="description"
          placeholder="Description"
          label={t('common.forms.description')}
          value={addEditForm.values?.description}
          onChange={(e) => {
            addEditForm.setFieldTouched('description', true, true);
            addEditForm.handleChange(e);
          }}
          error={addEditForm.touched.description && Boolean(addEditForm.errors.description)}
          errorText={addEditForm.touched.description && addEditForm.errors.description}
        />
      </div>

      {/* Delete Button */}
      {/* {!!deleteHandler && (
        <div
          className="mt-4 text-red-600 flex items-center gap-1 cursor-pointer text-sm font-medium"
          role="presentation"
          onClick={() => setOpen(true)}
        >
          <span>{t('common.general.delete')}</span>
          <BinOutlinedIcon />
        </div>
      )} */}

      {/* <DeleteDialog
        open={open}
        closeHandler={() => setOpen(false)}
        confirmHandler={deleteHandler}
        config={deleteModalConfig.works}
      /> */}
    </div>
  );
}

export default WorksForm;
